/* global axios */
import ApiClient from './ApiClient';

class AccountAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  // Override get to use the correct URL without trailing slash
  get() {
    return axios.get(`${this.apiVersion}/accounts/${this.accountIdFromRoute}`);
  }

  // Override update to use the correct URL without trailing slash
  update(id, data) {
    return axios.patch(
      `${this.apiVersion}/accounts/${this.accountIdFromRoute}`,
      data
    );
  }

  createAccount(data) {
    return axios.post(`${this.apiVersion}/accounts`, data);
  }

  async getCacheKeys() {
    const response = await axios.get(
      `/api/v1/accounts/${this.accountIdFromRoute}/cache_keys`
    );
    return response.data.cache_keys;
  }
}

export default new AccountAPI();
